var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{style:({
      textAlign: 'center',
      font: 'normal normal 600 36px/55px Poppins',
      letterSpacing: '0',
      color: '#333333',
      textTransform: 'uppercase',
      margin: _vm.$vuetify.breakpoint.mdAndUp ? '30px 0' : '20px 0'
    })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{style:({
      textAlign: 'center',
      font: 'normal normal normal 18px/35px Lato',
      letterSpacing: '0',
      color: '#777777',
      marginBottom: _vm.$vuetify.breakpoint.mdAndUp ? '60px' : '30px',
      padding: _vm.$vuetify.breakpoint.mdAndUp ? '0 200px' : '0 15px'
    })},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }